var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pt-5 pb-5 is-max-desktop",
      attrs: { id: "evaluation-panel" },
    },
    [
      _c("EvaluationBreadcrumb", { attrs: { links: _vm.links } }),
      _c("div", { staticClass: "box" }, [
        _c("header", { staticClass: "summary-header" }, [
          _c(
            "article",
            { attrs: { id: "summary-client" } },
            [
              _vm.evaluation &&
              _vm.evaluation.applicationDate !== "" &&
              _vm.evaluation.applicationDate !== null &&
              _vm.evaluation.applicationDate !== "0000-00-00"
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        type: "is-primary is-light mr-4",
                        icon: "calendar-days",
                        "data-cy": "aplicationDate",
                        rounded: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatDate(_vm.evaluation.applicationDate)
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.evaluation &&
              _vm.evaluation.simulationOrigin !== "" &&
              _vm.evaluation.simulationOrigin !== null
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        type: "is-primary is-light mr-4",
                        icon: "location-arrow",
                        "data-cy": "simulationOrigin",
                        rounded: "",
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.evaluation.simulationOrigin) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.evaluation &&
              _vm.evaluation.type !== "" &&
              _vm.evaluation.type !== null
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        type: "is-primary is-light mr-4",
                        icon:
                          _vm.evaluation.type === "automatic"
                            ? "robot"
                            : "circle-user",
                        "data-cy": "automatic",
                        rounded: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.evaluation.type === "automatic"
                              ? "Automática"
                              : "Manual"
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.evaluation &&
              _vm.evaluation.future !== "" &&
              _vm.evaluation.future !== null
                ? _c(
                    "b-tag",
                    {
                      attrs: {
                        type: "is-primary is-light mr-4",
                        icon: _vm.evaluation.future
                          ? "hourglass-start"
                          : "bolt",
                        "data-cy": "future",
                        rounded: "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.evaluation.future ? "Futura" : "Inmediata"
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm.isLoadingEvaluation && !_vm.isUnauthorizedError
        ? _c("Spinner")
        : _vm.evaluation && !_vm.isUnauthorizedError
        ? _c(
            "div",
            [
              _c("EvaluationHeader", { attrs: { debtor: _vm.debtor } }),
              _c("b-button", {
                attrs: {
                  id: "btn-home",
                  "icon-left": "home",
                  type: "is-primary is-light is-rounded",
                },
                on: { click: _vm.goHome },
              }),
              _c(
                "b-steps",
                {
                  attrs: {
                    id: "evaluation-steps",
                    "has-navigation": _vm.hasNavigation,
                    "label-position": "right",
                    animated: "",
                    rounded: "",
                  },
                  model: {
                    value: _vm.activeStep,
                    callback: function ($$v) {
                      _vm.activeStep = $$v
                    },
                    expression: "activeStep",
                  },
                },
                [
                  _c(
                    "b-step-item",
                    {
                      attrs: {
                        label: "Simulación",
                        step: 0,
                        clickable: false,
                        type: _vm.stepProperties(0).type,
                        icon: _vm.stepProperties(0).icon,
                      },
                    },
                    [_c("Simulation")],
                    1
                  ),
                  _c(
                    "b-step-item",
                    {
                      attrs: {
                        label: "Elegibilidad",
                        step: 1,
                        clickable: false,
                        type: _vm.stepProperties(1).type,
                        icon: _vm.stepProperties(1).icon,
                      },
                    },
                    [_c("EligibilityCriteria")],
                    1
                  ),
                  _c(
                    "b-step-item",
                    {
                      attrs: {
                        label: "Renta",
                        step: 2,
                        clickable: false,
                        type: _vm.stepProperties(2).type,
                        icon: _vm.stepProperties(2).icon,
                      },
                    },
                    [
                      _c("Income", {
                        attrs: {
                          label: "Renta",
                          "evaluation-id": _vm.generatedEvaluationId,
                          "one-client-id": _vm.evaluation.oneClientId,
                        },
                        on: {
                          "new-income-created": _vm.newIncomeCreated,
                          "income-documents-uploaded": _vm.incomeHasDocuments,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-step-item",
                    {
                      attrs: {
                        label: "Deuda",
                        step: 3,
                        clickable: false,
                        type: _vm.stepProperties(3).type,
                        icon: _vm.stepProperties(3).icon,
                      },
                    },
                    [
                      _c("Debt", {
                        attrs: {
                          label: "Deuda",
                          "evaluation-id": _vm.generatedEvaluationId,
                          "one-client-id": _vm.evaluation.oneClientId,
                        },
                        on: {
                          "new-debt-created": _vm.newDebtCreated,
                          "new-debt-empty": _vm.onNewDebtEmpty,
                          "debt-documents-uploaded": _vm.debtHasDocuments,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-step-item",
                    {
                      attrs: {
                        label: "Resumen",
                        step: 4,
                        clickable: false,
                        type: _vm.stepProperties(4).type,
                        icon: _vm.stepProperties(4).icon,
                      },
                    },
                    [_c("Resume", { attrs: { evaluation: _vm.evaluation } })],
                    1
                  ),
                  _c(
                    "div",
                    { class: _vm.buttonClass(_vm.activeStep) },
                    [
                      _vm.activeStep !== 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "is-secondary",
                              attrs: {
                                outlined: "",
                                type: "is",
                                "icon-pack": "fas",
                                "icon-left": "chevron-left",
                                "data-cy": "previousStep",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handlePreviousStep.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(" Anterior ")]
                          )
                        : _vm._e(),
                      !_vm.isLastStep
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: !_vm.nextButtonEnable,
                                type: "is-danger",
                                "icon-pack": "fas",
                                "icon-right": "chevron-right",
                                "data-cy": "nextStep",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleNextStep.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(" Siguiente ")]
                          )
                        : _vm._e(),
                      _vm.isReadyForRatify()
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                type: "is-danger",
                                "icon-pack": "fas",
                                "icon-right": "chevron-right",
                                "data-cy": "ratifyButton",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.enableShowConfirmation.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v(" Ratificar ")]
                          )
                        : _vm._e(),
                      _vm.showConfirmation
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "is-flex-desktop is-align-items-center",
                              attrs: { "data-cy": "confirmation-dialog" },
                            },
                            [
                              _c("p", { staticClass: "is-pulled-left mr-4" }, [
                                _vm._v(
                                  "¿Seguro quieres ratificar la verificación?"
                                ),
                              ]),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "is-danger",
                                    "data-cy": "button-confirm",
                                  },
                                  on: { click: _vm.ratify },
                                },
                                [_vm._v("Sí")]
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "is-text",
                                    "data-cy": "button-cancel",
                                  },
                                  on: { click: _vm.cancelRatification },
                                },
                                [_vm._v(" No ")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isUnauthorizedError
        ? _c(
            "b-notification",
            {
              staticClass: "mb-54",
              staticStyle: { "border-radius": "10px" },
              attrs: {
                type: "is-warning is-light",
                "has-icon": "",
                "aria-close-label": "Close notification",
                role: "alert",
              },
            },
            [_vm._v(" No cuentas con permisos para gestionar este proceso. ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }